var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "barcode-scanner" }, [
    _vm.showScanner
      ? _c("div", { staticClass: "scanner-fullscreen" }, [
          _c("div", { staticClass: "scanner-header" }, [
            _c(
              "button",
              { staticClass: "close-btn", on: { click: _vm.closeScanner } },
              [_vm._v("×")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "scanner-content" }, [
            _c(
              "div",
              {
                ref: "scannerArea",
                staticClass: "scanner-area",
                attrs: { id: "scanner" },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "scanner-close-btn",
                    on: { click: _vm.closeScanner },
                  },
                  [_vm._v("×")]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "loading-overlay" }, [
          _c("div", { staticClass: "loading-spinner" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scanner-overlay" }, [
      _c("div", { staticClass: "scanner-frame" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }